module.exports = __webpack_public_path__ + "svgs/expired.95045978.svg";